/** hr 系统路由 **/
import Layout from "@/views/layout/Layout";
// component: () => import("@/views/hrMan/orgPlan/index"),
const examRouter = {
  path: "/examMan",
  component: Layout,
  redirect: "/examMan/course/list",
  name: "examMan",
  meta: {
    title: "教培管理",
    icon: "examMan",
    roles: ["jiaopeiguanli_web"]
  },
  
  children: [
    // src\views\examMan\dashboard
    // {
    //   path: "dashboard",
    //   component: () => import("@/views/examMan/dashboard/index.vue"),
    //   name: "examMan",
    //   meta: {
    //     title: "管理首页",
    //     roles: ["renliziyuan"]
    //   },
    //   // hidden: true
    // },
    // ========= admin
    {
      path: "course",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "Course",
      meta: {
        title: "课程管理",
        roles: ["kechengguanli_web"]
      },
      children: [
        {
          path: "list",
          component: () => import("@/views/examMan/admin/course/index"),
          name: "CourseList",
          meta: {
            title: "课程管理",
            roles: ["kc_kechengguanli_web"]
          },

        },
        {
          path: "add",
          component: () => import("@/views/examMan/admin/course/form"),
          name: "CourseAdd",
          meta: {
            title: "添加课程",
            activeMenu: '/examMan/course/list'
          },
          hidden: true
        },
        {
          path: "update/:id",
          component: () => import("@/views/examMan/admin/course/form"),
          name: "CourseUpdate",
          meta: {
            title: "修改课程",
            activeMenu: '/examMan/course/list'
          },
          hidden: true
        },
        {
          path: "stat/:courseId",
          component: () => import("@/views/examMan/admin/course/stat"),
          name: "CourseStat",
          meta: {
            title: "统计总览",
            activeMenu: '/examMan/course/list'
          },
          hidden: true
        },
        {
          path: "file",
          component: () => import("@/views/examMan/admin/course/file"),
          name: "CourseFileList",
          meta: {
            title: "课件管理",
            roles: ["kc_kejianguanli_web"]
          },
          // hidden: true
        },
        {
          path: "qa",
          component: () => import("@/views/examMan/admin/course/qa"),
          name: "CourseQa",
          meta: {
            title: "问答管理",
            roles: ["kc_wendaguanli_web"]
          },
          // hidden: true
        },
        {
          path: "userStat",
          component: () => import("@/views/examMan/admin/course/userStat"),
          name: "CourseUserStat",
          meta: {
            title: "用户学习统计",
            roles: ["kc_yonghuxuexitongji_web"]
          },
          // hidden: true
        },
        // {
        //   path: "order",
        //   component: () => import("@/views/examMan/admin/order/course"),
        //   name: "CourserOrder",
        //   meta: {
        //     title: "课程订单",
        //     roles: ["renliziyuan"]
        //   },
        //   // hidden: true
        // },

      ]
    },
    {
      path: "exam",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "Exam",
      meta: {
        title: "考试管理",
        roles: ["kaoshiguanli_web"]
      },
      children: [
        {
          path: "exam",
          component: () => import("@/views/examMan/admin/exam/exam"),
          name: "ExamList",
          meta: {
            title: "在线考试",
            roles: ["ks_zaixiankaoshi_web"]
          },
          // hidden: true
        },
        {
          path: "add/:tmplId",
          component: () => import("@/views/examMan/admin/exam/exam/form"),
          name: "ExamAdd",
          meta: {
            title: "添加考试",
            activeMenu: '/examMan/exam/exam'
          },
          hidden: true
        },
        {
          path: "update/:id",
          component: () => import("@/views/examMan/admin/exam/exam/form"),
          name: "ExamUpdate",
          meta: {
            title: "修改考试",
            activeMenu: '/examMan/exam/exam'
          },
          hidden: true
        },
        {
          path: "examDetail/:examId",
          component: () => import("@/views/examMan/admin/exam/exam/stat"),
          name: "ExamDetail",
          meta: {
            title: "考试明细",
            activeMenu: '/examMan/exam/exam'
          },
          hidden: true
        },
        {
          path: "watch/:examId",
          component: () => import("@/views/examMan/admin/exam/watch"),
          name: "ExamWatch",
          meta: {
            title: "在线监考",
            activeMenu: '/examMan/exam/exam'
          },
          hidden: true
        },
        {
          path: "offline",
          component: () => import("@/views/examMan/admin/exam/offline"),
          name: "ExamOffline",
          meta: {
            title: "线下考试",
            roles: ["ks_xianxiakaoshi_web"]
          },
          // hidden: true
        },
        {
          path: "offlineRecords",
          component: () => import("@/views/examMan/admin/exam/offline/records"),
          name: "ExamOfflineRecords",
          meta: {
            title: "成绩管理",
            activeMenu: '/examMan/exam/offline'
          },
          hidden: true
        },
        {
          path: "review",
          component: () => import("@/views/examMan/admin/exam/review"),
          name: "ReviewList",
          meta: {
            title: "阅卷管理",
            roles: ["ks_yuejuanguanli_web"]
          },
          // hidden: true
        },
        {
          path: "review-list/:examId",
          component: () => import("@/views/examMan/admin/paper/paper/review"),
          name: "ReviewPaper",
          meta: {
            title: "试卷列表",
            activeMenu: '/examMan/exam/review'
          },
          hidden: true
        },
        {
          path: "review-detail/:paperId",
          component: () => import("@/views/examMan/admin/paper/paper/detail"),
          name: "ReviewPaperDetail",
          meta: {
            title: "试卷详情",
            activeMenu: '/examMan/exam/review'

          },
          hidden: true
        },
        {
          path: "tmpl/list",
          component: () => import("@/views/examMan/admin/tmpl"),
          name: "ExamTmpl",
          meta: {
            title: "试卷管理",
            roles: ["ks_shijuanguanli_web"]
          },
          // hidden: true
        },
        {
          path: "tmpl/add/:title/:catId/:joinType/:timeType",
          component: () => import("@/views/examMan/admin/tmpl/form"),
          name: "ExamTmplAdd",
          meta: {
            title: "添加试卷",
            activeMenu: '/examMan/exam/tmpl/list'
          },
          hidden: true
        },
        {
          path: "tmpl/upadte/:id",
          component: () => import("@/views/examMan/admin/tmpl/form"),
          name: "ExamTmplUpdate",
          meta: {
            title: "修改试卷",
            activeMenu: '/examMan/exam/tmpl/list'
          },
          hidden: true
        },
        {
          path: "tmpl/preview/:id",
          component: () => import("@/views/examMan/admin/tmpl/preview"),
          name: "ExamTmplPreview",
          meta: {
            title: "预览试卷",
            activeMenu: '/examMan/exam/tmpl/list'
          },
          hidden: true
        },
        {
          path: "stat",
          component: () => import("@/views/examMan/admin/exam/stat"),
          name: "ExamStat",
          meta: {
            title: "考试统计",
            roles: ["ks_kaoshitongji_web"]
          },
          // hidden: true
        },
        {
          path: "stat/result",
          component: () => import("@/views/examMan/admin/exam/stat/result"),
          name: "ExamStatResult",
          meta: {
            title: "统计结果",
            activeMenu: '/examMan/exam/stat'

          },
          hidden: true
        },

      ]
    },


    {
      path: "repo",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "Repo",
      meta: {
        title: "题库管理",
        roles: ["tikuguanli_web"]
      },
      children: [
        {
          path: "repo",
          component: () => import("@/views/examMan/admin/repo"),
          name: "RepoList",
          meta: {
            title: "题库管理",
            roles: ["tk_tikuguanli_web"]
          },
          // hidden: true
        },
        {
          path: "repo/add",
          component: () => import("@/views/examMan/admin/repo/form"),
          name: "RepoAdd",
          meta: {
            title: "添加题库",
            activeMenu: '/examMan/repo/repo'
          },
          hidden: true
        },
        {
          path: "repo/update/:id",
          component: () => import("@/views/examMan/admin/repo/form"),
          name: "RepoUpdate",
          meta: {
            title: "修改题库",
            activeMenu: '/examMan/repo/repo'

          },
          hidden: true
        },
        {
          path: "qu",
          component: () => import("@/views/examMan/admin/repo/qu"),
          name: "QuList",
          meta: {
            title: "试题管理",
            roles: ["tk_shitiguanli_web"]
          },
          // hidden: true
        },
        {
          path: "qu/add",
          component: () => import("@/views/examMan/admin/repo/qu/form"),
          name: "QuAdd",
          meta: {
            title: "添加试题",
            activeMenu: '/examMan/repo/qu'
          },
          hidden: true
        },
        {
          path: "qu/update/:id",
          component: () => import("@/views/examMan/admin/repo/qu/form"),
          name: "QuUpdate",
          meta: {
            title: "修改试题",
            activeMenu: '/examMan/repo/qu'
          },
          hidden: true
        },
        {
          path: "stat",
          component: () => import("@/views/examMan/admin/repo/stat"),
          name: "RepoStat",
          meta: {
            title: "训练统计",
            roles: ["tk_xunliantongji_web"]
          },
          // hidden: true
        },
      ]
    },

    {
      path: "user",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "User",
      meta: {
        title: "用户管理",
        roles: ["yonghuguanli_web"]
      },
      children: [
        {
          path: "group",
          component: () => import("@/views/examMan/admin/sys/group"),
          name: "SysUserGroup",
          meta: {
            title: "群组管理",
            roles: ["yh_qunzuguanli_web"]
          },
          // hidden: true
          children: []
        },
      ]
    },

    {
      path: "sys",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "Sys",
      meta: {
        title: "系统设置",
        roles: ["xitongshezhi_web"]
      },
      children: [
        {
          path: "config",
          component: () => import("@/views/examMan/admin/sys/config"),
          name: "SysConfig",
          meta: {
            title: "系统配置",
            roles: ["xt_xitongpeizhi_web"]
          },
          // hidden: true
          children: []
        },

        {
          path: "dict-catalog",
          component: () => import("@/views/examMan/admin/sys/dict/catalog"),
          name: "SysDictCatalog",
          meta: {
            title: "分类字典",
            roles: ["xt_fenleizidian_web"]
          },
          // hidden: true
          children: []
        },
        {
          path: "dict-data",
          component: () => import("@/views/examMan/admin/sys/dict/dict"),
          name: "SysDictDict",
          meta: {
            title: "数据字典",
            roles: ["xt_shujuzidian_web"]
          },
          // hidden: true
          children: []
        },
        {
          path: "banner",
          component: () => import("@/views/examMan/admin/sys/banner"),
          name: "BannerList",
          meta: {
            title: "轮播管理",
            roles: ["xt_lunboguanli_web"]
          },
          // hidden: true
          children: []
        },
      ]
    },
    // ========= web
    {
      path: "studyOnline",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "StudyOnline",
      meta: {
        title: "在线学习",
        roles: ["zaixianxuexi_web"]
      },
      children: [
        {
          path: "kechengxuexi",
          component: () => import("@/views/examMan/web/course/list"),
          name: "CourseLearn",
          meta: {
            title: "课程学习",
            roles: ["zsxx_kechengxuexi_web"]
          },
          // hidden: true
        },
        {
          path: "web/course/view/:courseId",
          component: () => import("@/views/examMan/web/course/view"),
          name: "CourseView",
          meta: {
            title: "课程详情",
            activeMenu:'/examMan/studyOnline/web/course'
          },
          hidden: true
        },
        {
          path: "web/course/view/:courseId/:fileId",
          component: () => import("@/views/examMan/web/course/view"),
          name: "CourseViewWithFile",
          meta: {
            title: "课程详情",
            activeMenu:'/examMan/studyOnline/web/course'
          },
          hidden: true
        },

        {
          path: "web/repo",
          component: () => import("@/views/examMan/web/repo"),
          name: "MyRepoList",
          meta: {
            title: "题库训练",
            roles: ["zsxx_tikuxunlian_web"]
          },
          // hidden: true
        },
        {
          path: "web/repo/view/:repoId",
          component: () => import("@/views/examMan/web/repo/view"),
          name: "MyRepoView",
          meta: {
            title: "题库训练",
            activeMenu:'/examMan/studyOnline/web/repo'
          },
          hidden: true
        },
        {
          path: "web/repo/training/:repoId/:mode",
          component: () => import("@/views/examMan/web/repo/training"),
          name: "MyRepoTraining",
          meta: {
            title: "开始训练",
            activeMenu:'/examMan/studyOnline/web/repo'
          },
          hidden: true
        },
        {
          path: "web/repo/repo/:trainId",
          component: () => import("@/views/examMan/web/repo/result"),
          name: "TrainResult",
          meta: {
            title: "训练结果",
            activeMenu:'/examMan/studyOnline/web/repo'
          },
          hidden: true
        },

      ]
    },
    
    {
      path: "examOnline",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "examOnline",
      meta: {
        title: "在线考试",
        roles: ["zaixiankaoshi_web"]
      },
      children: [
        {
          path: "zaixiankaoshi",
          component: () => import("@/views/examMan/web/exam/list"),
          name: "ExamOnline",
          meta: {
            title: "在线考试",
            roles: ["zsks_zaixiankaoshi_web"]
          },
          // hidden: true
          children:[]
        },
        {
          path: "web/exam/check/:id",
          component: () => import("@/views/examMan/web/exam/check"),
          name: "CheckExam",
          meta: {
            title: "考试校验",
            activeMenu:'/examMan/examOnline/web/index'
          },
          hidden: true
        },
        {
          path: 'web/exam/start/:id',
          // path: 'web/exam/start',
          component: () => import("@/views/examMan/web/exam/exam"),
          name: 'StartExam',
          meta: {
            title: "开始考试",
            activeMenu:'/examMan/examOnline/web/index'
          },
          hidden: true
        },
        {
          path: "web/exam/result/:id",
          component: () => import("@/views/examMan/web/exam/result"),
          name: "ShowExam",
          meta: {
            title: "考试结果",
            activeMenu:'/examMan/examOnline/web/index'
          },
          hidden: true
        },

      ]
    },

    {
      path: "uc",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "examUc",
      meta: {
        title: "用户中心",
        roles: ["yonghuzhongxin_web"]
      },
      children: [
        {
          path: "web/achievement",
          component: () => import("@/views/examMan/web/paper/total"),
          name: "examAchievement",
          meta: {
            title: "考试成绩",
            roles: ["yh_kaoshichengji_web"]
          },
          // hidden: true
        },
        {
          path: "web/paper/list/:examId/:userId",
          component: () => import("@/views/examMan/web/paper/list"),
          name: "WebPaperList",
          meta: {
            title: "考试记录",
            activeMenu:'/examMan/uc/web/achievement'
          },
          hidden: true
        },
        {
          path: "web/book/list/:examId",
          component: () => import("@/views/examMan/web/book"),
          name: "BookList",
          meta: {
            title: "考试错题",
            activeMenu:'/examMan/uc/web/achievement'
          },
          hidden: true
        },

        {
          path: "web/qu/view/:id",
          component: () => import("@/views/examMan/web/qu/view"),
          name: "ViewQu",
          meta: {
            title: "试题详情",
            activeMenu:'/examMan/uc/web/achievement'
          },
          hidden: true
        },
        {
          path: "web/repo/TrainHistory",
          component: () => import("@/views/examMan/web/ucenter/components/TrainHistory"),
          name: "TrainHistory",
          meta: {
            title: "训练记录",
            roles: ["yh_xunlianjilu_web"],
          },
          hidden: true
        },

        {
          path: "web/learn",
          component: () => import("@/views/examMan/web/ucenter/components/MyFileLearn/index.vue"),
          name: "examLearn",
          meta: {
            title: "学习记录",
            roles: ["yh_xuexijilu_web"]
          },
          // hidden: true
        },
        {
          path: "web/ask",
          // /views/web/course/qa
          component: () => import("@/views/examMan/web/course/qa"),
          name: "examAsk",
          meta: {
            title: "学习问答",
            roles: ["yh_xuexiwenda_web"]
          },
          // hidden: true
        },
      ]
    },


  ]

};

export default examRouter;
